<template>
    <v-card
        class="cookie-disclaimer px-12 py-6"
        :max-height="cardHeight"
    >
        <DisclaimerBody
            :isSettings="isSettings"
            @accept-policies="acceptPolicies"
            @open-settings="openSettings"
            @reject-policies="rejectPolicies"
            @save-custom-settings="saveSettings"
        />
        <DisclaimerFooter
            v-if="!isSettings"
            @open-settings="openSettings"
            @accept-policies="acceptPolicies"
            @reject-policies="rejectPolicies"
        />
    </v-card>
</template>

<script>
    import DisclaimerBody from '@/components/gdpr/layout/DisclaimerBody';
    import DisclaimerFooter from '@/components/gdpr/layout/DisclaimerFooter';

    export default {
        name: 'CookieCard',
        components: {
            DisclaimerBody,
            DisclaimerFooter
        },
        computed: {
            cardHeight() {
                if (this.$vuetify.breakpoint.height > 700 && this.$vuetify.breakpoint.mdAndUp)
                    return 1000;
                else if (this.$vuetify.breakpoint.height <= 700 && (this.$vuetify.breakpoint.height > 500 && this.$vuetify.breakpoint.mdAndUp))
                    return 500;
                else if (this.$vuetify.breakpoint.smAndDown)
                    return null;
            }
        },
        data() {
            return {
                isSettings: false
            }
        },
        methods: {
            openSettings() {
                this.isSettings = !this.isSettings;
            },
            acceptPolicies() {
                this.$emit('accept-policies');
            },
            rejectPolicies() {
                this.$emit('reject-policies');
            },
            saveSettings() {
                this.$emit('save-custom-settings');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/CookieCard.vue